let videos = document.querySelectorAll('.play-button:not(.alt)');

videos.forEach(function (el) {
    el.addEventListener('click', function () {
        if (this.parentElement.classList.contains('play')) {
            this.parentElement.classList.remove('play');
            this.nextElementSibling.pause();
            this.querySelector('.icon-text').innerText = this.querySelector('.icon-text').getAttribute('data-play');
        } else {
            this.parentElement.classList.add('play');
            this.nextElementSibling.play();
            this.querySelector('.icon-text').innerText = this.querySelector('.icon-text').getAttribute('data-pause');
        }
    });
});
